import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlashService } from '../flash/services/flash.service';
import clipboard from '../../utils/clipboard';

@Component({
  selector: 'app-dialog-token-success-v2',
  templateUrl: './dialog-token-success-v2.component.html',
  styleUrls: ['./dialog-token-success-v2.component.sass']
})
export class DialogTokenSuccessV2Component {
  token: any;

  constructor(
    public dialogRef: MatDialogRef<DialogTokenSuccessV2Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private flashService: FlashService,
  ) {
    this.token = data.token;
  }

  onCopyClientId() {
    clipboard(this.token.client_id);
    this.flashService.success('Client ID copied to clipboard');
  }

  onCopySecret() {
    clipboard(this.token.client_secret);
    this.flashService.success('Client Secret copied to clipboard');
  }

  onClose() {
    this.dialogRef.close();
  }
}
